import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FileText, BookOpen, MessageSquare, Eye, Plus } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getToken = () => localStorage.getItem("brgt_token");
const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const user = JSON.parse(localStorage.getItem("brgt_user") || "{}");

  useEffect(() => {
    axios.get(`${API}/admin/stats`, authHeaders())
      .then(r => setStats(r.data))
      .catch(() => {});
  }, []);

  const cards = stats ? [
    { label: "Total Pages", value: stats.total_pages, icon: FileText, color: "bg-blue-50 text-navy", link: "/admin/pages" },
    { label: "Published Blogs", value: `${stats.published_blogs}/${stats.total_blogs}`, icon: BookOpen, color: "bg-amber-50 text-amber-dark", link: "/admin/blogs" },
    { label: "New Contacts", value: stats.new_contacts, icon: MessageSquare, color: "bg-emerald-50 text-emerald-600", link: "/admin/contacts" },
    { label: "Total Submissions", value: stats.total_contacts, icon: Eye, color: "bg-slate-50 text-slate-600", link: "/admin/contacts" },
  ] : [];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="font-heading text-2xl font-bold text-navy" data-testid="dashboard-title">
          Welcome back, {user.name || "Admin"}
        </h1>
        <p className="text-slate-500 text-sm mt-1">Manage your brgt.ai website content</p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((card) => {
          const Icon = card.icon;
          return (
            <Link
              key={card.label}
              to={card.link}
              data-testid={`stat-card-${card.label.toLowerCase().replace(/\s/g, '-')}`}
              className={`${card.color} rounded-xl p-6 border border-slate-100 hover:-translate-y-0.5 transition-transform`}
            >
              <div className="flex items-center justify-between mb-3">
                <Icon size={20} />
              </div>
              <p className="text-2xl font-heading font-bold">{card.value}</p>
              <p className="text-xs text-slate-500 mt-1">{card.label}</p>
            </Link>
          );
        })}
      </div>

      {/* Quick Actions */}
      <div className="bg-white rounded-xl border border-slate-100 p-6">
        <h2 className="font-heading font-semibold text-navy text-lg mb-4">Quick Actions</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <Link
            to="/admin/blogs/new"
            data-testid="quick-action-new-blog"
            className="flex items-center gap-3 bg-navy/5 hover:bg-navy/10 rounded-lg p-4 transition-colors"
          >
            <Plus size={18} className="text-navy" />
            <span className="text-sm font-medium text-navy">New Blog Post</span>
          </Link>
          <Link
            to="/admin/pages"
            data-testid="quick-action-edit-pages"
            className="flex items-center gap-3 bg-amber/5 hover:bg-amber/10 rounded-lg p-4 transition-colors"
          >
            <FileText size={18} className="text-amber" />
            <span className="text-sm font-medium text-navy">Edit Pages</span>
          </Link>
          <Link
            to="/admin/contacts"
            data-testid="quick-action-view-contacts"
            className="flex items-center gap-3 bg-emerald-50 hover:bg-emerald-100 rounded-lg p-4 transition-colors"
          >
            <MessageSquare size={18} className="text-emerald-600" />
            <span className="text-sm font-medium text-navy">View Contacts</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
